import { BsClipboardPlusFill } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";
import PopUpshowDetailbom from './popUpshowDetailbom';
import ViewJournaldetail from "../components/componentallistallpprovebyuser/viewJournaldetail";

import { Link } from "react-router-dom";
import TdsCodeCell from '../components/TdsCodeCell';
export const columns = [
    {
        name: 'TDS code',
        sortable: true,
        // grow: 1,
        width: '150px',
        selector: row => row.tdscode,
        cell: row => <TdsCodeCell tdscode={row.tdscode} revision={row.revision} />,
    },
    {
        name: 'Datetime Approved',
         sortable: true,
        width: '170px',
        selector: row => row.datetime_approved,
    },
    {
        name: 'Journal Type',
        selector: row => row.journaltype,
        grow: 1.5,
    },
    {
        name: 'customer/productname',
        grow: 1.5,
        selector: row => <div style={{ flexDirection: 'column' }}>
            <div>: {row.customername}</div>
            <div>: {row.productname}</div>
            <div>
                <label style={{ color: 'red' }}>
                    ผู้สร้าง คุณ :{row.createbyName}
                </label>
            </div>
        </div>,
    },
    {
        name: 'สร้าง bom',
        center: true,
       
        // headerAlign: 'right',
         selector: row =>
        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
            {row.newbom=='1'&&<FaCheckCircle color="green" size={20}/>}
        </div>,
    },
    {
        name: 'สร้าง route',
        selector: row => <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
            {row.newroute=='1'&&<FaCheckCircle color="green" size={20}/>}
        </div>,
    },
    {
        name: 'createdate',
         sortable: true,
        selector: row => row.createdate,
    },
    {
        name: 'Action',
        grow: 1.5,
        cell: row => <div style={{flexDirection:'row',display:'flex',
        justifyContent:'center',alignItems:'center'}}>
            <ViewJournaldetail jourId={row.journalId} codeId={row.tdscode} revise={row.revision}/>
            <PopUpshowDetailbom ids={row.journalId}/>
            {/* <Link to={`/addregisterbom/${row.journalId}`} >
                <BsClipboardPlusFill size={25} />
            </Link> */}

        </div>
    },

];